import script from "./desktopIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./desktopIcon.vue?vue&type=script&setup=true&lang=js"

import "./desktopIcon.vue?vue&type=style&index=0&id=4a4fed5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4fed5c"]])

export default __exports__